(function($) {
  $('.banner-slider').slick({
    fade: true,
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 6000,
    pauseOnHover: false,
  });
  $('.repair-slider').slick({
    autoplay: true,
    arrows: true,
    dots: false,
    speed: 300,
  });
})($);